import { EntityWithIdAndDescription } from 'src/types'

export const OperacionCLFBAgregadosFields = {
    AgregadoImporte: 'agregadoImporte',
    Absoluto: 'Absoluto'
} as const

export type OperacionCLFBAgregadosVista = EntityWithIdAndDescription & {
    [OperacionCLFBAgregadosFields.AgregadoImporte]: number,
    [OperacionCLFBAgregadosFields.Absoluto]: boolean
}

export const OperacionCLFBLimitesFields = {
    LimiteImporte: 'limiteImporte'
} as const

export type OperacionCLFBLimitesVista = EntityWithIdAndDescription & {
    [OperacionCLFBLimitesFields.LimiteImporte]: number
}

export const OperacionCLFBConcentracionesFields = {
    ConcentracionImporte: 'concentracionImporte'
} as const

export type OperacionCLFBConcentracionesVista = EntityWithIdAndDescription & {
    [OperacionCLFBConcentracionesFields.ConcentracionImporte]: number
}

export const OperacionCLFBHoldingPeriodsFields = {
    HoldingPeriodDias: 'holdingPeriodDias'
} as const

export type OperacionCLFBHoldingPeriodsVista = EntityWithIdAndDescription & {
    [OperacionCLFBHoldingPeriodsFields.HoldingPeriodDias]: number
}